/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "colors_default": "text-white bg-al-petroleum-600 hover:bg-al-petroleum-400 focus:bg-al-petroleum-600 active:bg-al-petroleum-800",
  "colors_text": "text-black",
  "size_small": "px-3 py-1 text-al-button-sm",
  "size_medium": "px-3 py-2 text-al-button-sm",
  "size_large": "px-6 py-3 text-al-button-sm",
  "size_text": "text-al-button-sm",
  "variant_default": "block rounded-full ring-0 active:ring-0 hover:ring-0 outline-none transition-all duration-200 ease-in-out whitespace-nowrap cursor-pointer focus:ring-0",
  "variant_text": "cursor-pointer"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Tag");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;